import { Gateway } from '@/entities/gateway';
import { chain, map } from 'fp-ts/lib/TaskEither';
import { flow, pipe } from 'fp-ts/lib/function';
import { detailCodec, formCodec, listCodec } from './codec';
import {
  addVersionForUpdate,
  createAuthorizedGetRequest,
  createAuthorizedPutRequest,
  decode,
  decodeVersioned,
  fetchApi,
  setBody,
  setQuery,
  Versioned,
} from '../..';
import { encodePaginatableQuery, PaginatableQuery } from '../../request';

const baseUrl = '/v2/gateways';
const recordUrl = (id: number): string => `${baseUrl}/${id}`;

export const list = (query: PaginatableQuery) => pipe(
  baseUrl,
  createAuthorizedGetRequest,
  map(setQuery(encodePaginatableQuery(query))),
  chain(fetchApi),
  chain(decode(listCodec)),
);

export const get = flow(
  recordUrl,
  createAuthorizedGetRequest,
  chain(fetchApi),
  chain(decodeVersioned(detailCodec)),
);

export const update = (id: number, gateway: Versioned<Gateway>) => pipe(
  id,
  recordUrl,
  createAuthorizedPutRequest,
  map(addVersionForUpdate(gateway.version)),
  map(setBody(formCodec.encode(gateway.data))),
  chain(fetchApi),
);
